import * as React from "react";

const Megaphone: React.FC = () => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.75 3.25C14.1484 3.25 14.5 3.60156 14.5 4V13C14.5 13.4219 14.1484 13.75 13.75 13.75C13.3281 13.75 13 13.4219 13 13V4C13 3.60156 13.3281 3.25 13.75 3.25ZM2.5 6.97656L12.25 4V13L9.15625 12.0859C8.92188 13.0469 8.03125 13.75 7 13.75C5.75781 13.75 4.75 12.7422 4.75 11.5C4.75 11.2422 4.77344 11.0078 4.86719 10.7734L2.5 10.0469C2.47656 10.4453 2.14844 10.75 1.75 10.75C1.32812 10.75 1 10.4219 1 10V7C1 6.60156 1.32812 6.25 1.75 6.25C2.14844 6.25 2.47656 6.57812 2.5 6.97656ZM8.10156 11.7578L5.94531 11.1016C5.89844 11.2188 5.875 11.3594 5.875 11.5C5.875 12.1328 6.36719 12.625 7 12.625C7.53906 12.625 7.98438 12.25 8.10156 11.7578Z"
                fill="#262525"
            />
        </svg>
    );
};

export default React.memo(Megaphone);
